import { Web3Provider } from '@ethersproject/providers';
import { BigNumber } from 'ethers';
import { hexStripZeros } from 'ethers/lib/utils';
import { CHAIN_INFO, SupportedChains } from '../../config/constants';
import addNetwork from './addNetwork';

type SwitchNetworkParams = {
    library: Web3Provider;
    chainId: SupportedChains;
};

const switchNetwork = async ({ library, chainId }: SwitchNetworkParams) => {
    if (!library.provider.request) return;

    try {
        const formattedChainId = hexStripZeros(BigNumber.from(chainId).toHexString());

        await library.provider.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: formattedChainId }],
        });
    } catch (error: any) {
        // 4902 is the error code for attempting to switch to an unrecognized chainId
        if (error?.code === 4902) {
            const chainInfo = CHAIN_INFO[chainId];

            try {
                if (!chainInfo) throw new Error('Error while reading Chain Info');

                await addNetwork({ library, chainId, chainInfo });
                await switchNetwork({ library, chainId });
            } catch (error) {
                throw error;
            }

            return;
        }

        throw error;
    }
};

export default switchNetwork;
